// src/components/bot/questions/EmailQuestion.tsx
// 🎨 EMAIL QUESTION COMPONENT - For email address input
// ✅ UPDATED: Removed placeholder field and false validation claims

import React from 'react';
import BaseQuestion from './BaseQuestion';
import styles from './Questions.module.css';
import { QuestionItem } from '../hooks/useBotForm';
import logger from '../../../utils/logger';

interface EmailQuestionProps {
  question: QuestionItem;
  index: number;
  onUpdate: (id: string, field: keyof QuestionItem, value: any) => void;
  onRemove: (id: string) => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  canMoveUp: boolean;
  canMoveDown: boolean;
  forceCollapsed?: boolean;
}

const EmailQuestion: React.FC<EmailQuestionProps> = (props) => {
  const { question } = props;

  logger.log('📧 EmailQuestion: Rendering simplified email question:', question.id);

  return (
    <BaseQuestion {...props}>
      
      {/* ❌ REMOVED: typeSpecificOptions section - no more placeholder field */}
      {/* ❌ REMOVED: validationInfo section with false validation claims */}

      {/* 🎯 EMAIL QUESTION PREVIEW - Simplified */}
      <div className={styles.questionPreview}>
        <div className={styles.previewLabel}>Preview:</div>
        <div className={styles.previewContent}>
          <div className={styles.previewQuestion}>
            {question.question || 'Enter your question above...'}
            {question.required && <span className={styles.requiredAsterisk}>*</span>}
          </div>
          <div className={styles.previewInput}>
            <input 
              type="email"
              placeholder="user@example.com"
              disabled
              className={styles.previewInputField}
            />
          </div>
        </div>
      </div>
      
    </BaseQuestion>
  );
};

export default EmailQuestion;